import React, { useState, useRef, useEffect } from 'react'
import { Pill } from '../ui'

const STATUS_OPTIONS = [
  { value: 'on_track', label: 'On track', tone: 'success' },
  { value: 'at_risk', label: 'At risk', tone: 'info' },
  { value: 'needs_focus', label: 'Needs focus', tone: 'danger' },
  // No semantic blue tone exists; ahead_of_plan reuses success since it's
  // also a positive signal. The visual distinction from on_track (also
  // success) is intentionally lost — see follow-up.
  { value: 'ahead_of_plan', label: 'Ahead of plan', tone: 'success' },
]

export function GoalStatusLabel({ value, onChange, readOnly = false }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  const current = STATUS_OPTIONS.find((o) => o.value === value) || STATUS_OPTIONS[0]

  if (readOnly) {
    return <Pill tone={current.tone}>{current.label}</Pill>
  }

  return (
    <div ref={ref} style={styles.wrapper}>
      <Pill
        as="button"
        type="button"
        tone={current.tone}
        onClick={() => setOpen((v) => !v)}
      >
        {current.label} ▾
      </Pill>
      {open && (
        <div style={styles.dropdown}>
          {STATUS_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              style={{ ...styles.dropdownItem, ...(opt.value === value ? styles.dropdownItemActive : {}) }}
              onClick={() => { onChange?.(opt.value); setOpen(false) }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  wrapper: { position: 'relative', display: 'inline-block' },
  // Custom dropdown menu — kept inline (no Menu primitive yet).
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: 'var(--space-1)',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow-md)',
    zIndex: 'var(--z-dropdown)',
    minWidth: 130,
    overflow: 'hidden',
  },
  dropdownItem: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '7px 12px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: 12,
    color: 'var(--text-primary)',
    fontFamily: 'inherit',
  },
  dropdownItemActive: {
    fontWeight: 600,
  },
}
